// ./context/initialStates/recognizedInstructorInitialState.js

const recognizedInstructorInitialState = {
  instructors: [],
  currentInstructor: null,
  isLoading: false,
  error: null
};

export default recognizedInstructorInitialState;